<script setup lang="ts">
import ListUsers from '@/components/BusinessLogic/Users/ListUsers.vue'
import { useUsers } from '@/composables/users/useUsers.ts'
import { useI18n } from 'vue-i18n'

const { createUserModalOpened } = useUsers()
const { locale, t } = useI18n({ useScope: 'global' })

const openAddUserModal = () => {
  createUserModalOpened.value = true
}
</script>

<template>
  <DevConfigurator />
  <div class="flex-1 min-h-0 flex flex-col w-full mx-auto h-full px-10 pb-10 pt-10 space-y-6">
    <h1 class="typography-heading-1">{{ t('navigation.users') }}</h1>
    <div class="flex-1 min-h-0 flex flex-col">
      <ListUsers :locale @onCreate="openAddUserModal" />
    </div>
  </div>
</template>
